import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getTranslationsForLang } from '@/translations';

const AVAILABLE_LANGUAGES = ['fr', 'en', 'es'] as const;
type Lang = typeof AVAILABLE_LANGUAGES[number];

const getSavedLanguage = (): Lang => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) {
      return 'fr';
    }
    const savedLang = localStorage.getItem('user-language');
    if (savedLang && (AVAILABLE_LANGUAGES as readonly string[]).includes(savedLang)) {
      return savedLang as Lang;
    }
    return 'fr';
  } catch {
    return 'fr';
  }
};

const activeLang = getSavedLanguage();

const initPromise = i18n
  .use(initReactI18next)
  .init({
    resources: {
      [activeLang]: { translation: getTranslationsForLang(activeLang) },
    },
    lng: activeLang,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
    keySeparator: '.',
    nsSeparator: ':',
  });

/**
 * Lazy-load another language bundle when the user switches language.
 */
export async function loadLanguage(lang: Lang): Promise<void> {
  if (i18n.hasResourceBundle(lang, 'translation')) {
    await i18n.changeLanguage(lang);
    return;
  }
  const translations = getTranslationsForLang(lang);
  i18n.addResourceBundle(lang, 'translation', translations, true, true);
  await i18n.changeLanguage(lang);
}

export { initPromise };
export default i18n;
